<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/layoutComponents/page-header'
import Table from '../../components/common/table/Table'
import TableHeader from '../../components/common/table/TableHeader'
import Pagination from '../../components/common/table/Pagination.vue'
import Excel from '../common/excel.vue'
import TeamTaskDataprovider from '../../services/teamtask'
import { teamTaskMixins, urlQueriesMixins } from '../../utils/mixins'
import axios from 'axios'
import { API_URL } from '../../../config/HTTP.js'
import Loader from '../../components/common/loader.vue'

export default {
  page: {
    title: 'جدول تیم تسک',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  mixins: [teamTaskMixins, urlQueriesMixins],
  components: {
    PageHeader,
    Table,
    TableHeader,
    Pagination,
    Excel,
    Loader,
  },
  data() {
    return {
      componentKey: 0,
      wannaExcel: null,
      forceReloadFlag: true,
      title: 'جدول تیم تسک',
      fields: [],
      filters: [],
      rows: [],
      downloadLink: '',
      dropDownListItems: [
        { id: 1, count: 10, value: 'نمایش 10 تایی', isDefault: true },
        { id: 2, count: 20, value: 'نمایش 20 تایی', isDefault: false },
        { id: 3, count: 50, value: 'نمایش 50 تایی', isDefault: false },
      ],
      loading: false,
      dotLoading: false,
    }
  },
  methods: {
    getData(queryParams) {
      this.dotLoading = true
      TeamTaskDataprovider.getTeamTaskDataTable(queryParams)
        .then(res => {
          this.$store.dispatch('teamTask/setDataTable', res.data)
          this.fields = this.dataTable.data.fields
          this.rows = this.dataTable.data.rows
          this.filters = this.dataTable.data.filters
          setTimeout(() => {
            this.forceRerender()
            this.loading = false
            this.dotLoading = false
          }, 300)
        })
        .catch(err => {
          this.loading = false
          this.dotLoading = false
        })
    },
    excelDownload() {
      this.wannaExcel = null
      axios
        .post(
          `${API_URL}/crmtt/api/Issue/ExportToXlsxListIssue`,
          { key: this.routeParam, query: this.searchQuery, pageSize: this.pageSize, pageNumber: this.currentPage },
          { responseType: 'blob' },
        )
        .then(res => {
          const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
          this.downloadLink = URL.createObjectURL(blob)
        })
    },
    forceRerender() {
      this.componentKey += 1
    },
  },
  computed: {
    routeParam() {
      return this.$route.params.slug
    },
    headerItems() {
      return [
        {
          text: 'داشبورد',
          href: '/',
        },
        {
          text: this.dataTable.data.name,
          active: true,
        },
      ]
    },
  },
  watch: {
    routeParam(newValue, oldValue) {
      let queryParams = {
        key: newValue,
      }
      if (newValue !== oldValue) {
        this.loading = true
        this.$store.dispatch('urlQueries/setSearchQuery', '')
        this.$store.dispatch('urlQueries/setCurrentPage', 1)
        this.$store.dispatch('urlQueries/setFields', [])
        this.$store.dispatch('urlQueries/setPageSize: ', 10)
        // this.forceReloadFlag = false
        // this.fields = []
        // this.rows = []
        this.getData(queryParams)
      }
    },
    wannaExcel(val) {
      if (val === true) {
        this.excelDownload()
      }
    },
  },
  created() {
    const route = this.$route
    const teamTaskType = route.params.slug
    let query = route.query.q ? route.query.q : ''
    let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
    let pageSize = route.query.pageSize ? route.query.pageSize : 10
    let filters = route.query.filters
    filters != undefined ? (filters = filters.split(',')) : []
    this.$store.dispatch('urlQueries/setSearchQuery', query)
    this.$store.dispatch('urlQueries/setCurrentPage', pageNumber)
    this.$store.dispatch('urlQueries/setFields', filters)
    this.$store.dispatch('urlQueries/setPageSize', pageSize)
    let queryParams = {
      key: teamTaskType,
      query: query,
      filters: filters,
      pageNumber: pageNumber,
    }
    this.getData(queryParams)
  },
}
</script>
<template>
  <div>
    <div v-if="!loading">
      <PageHeader :title="dataTable.data.name" :items="headerItems" />
      <div class="" style="overflow-x: auto">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <TableHeader
                :isActive="false"
                searchVisible
                url="teamtask/board"
                :changeGrid="true"
                actionClass="d-flex align-items-center justify-content-between"
                :notDropdown="true"
                :filterList="filters"
                :getData="getData"
              />
              <Table
                :key="componentKey"
                :titleVisible="true"
                :descriptionVisible="true"
                :filterVisible="true"
                :changeGrid="true"
                selectRoute="teamtask/details"
                :title="dataTable.data.name"
                description="تست"
                :selectOption="true"
                hover="true"
                :isCrm="true"
                :fields="fields"
                :rows="rows"
              >
              <template v-slot:emptyTable>
                  <Loader :loading="dotLoading" />
                </template>
              </Table>
              <Pagination :paginationData="dataTable.pagination" :pageOptions="pageOptions" :dropDownListItems="dropDownListItems" :getData="getData">
                <template v-slot:excel>
                  <Excel :link="downloadLink" @downloadExcel="wannaExcel = $event" />
                </template>
              </Pagination>
            </div>
          </div>
        </div>
      </div>

      <!-- <PageHeader :title="dataTable.data.name" :items="headerItems" />
    <Table
      v-if="forceReloadFlag"
      :titleVisible="true"
      :descriptionVisible="true"
      :filterVisible="true"
      :changeGrid="true"
      selectRoute="teamtask/details"
      :title="dataTable.data.name"
      description="تست"
      :selectOption="true"
      hover="true"
      :isCrm="true"
      :fields="fields"
      :rows="rows"
    >
      <template v-slot:TableHeader>
        <TableHeader
          v-if="forceReloadFlag"
          :isActive="false"
          searchVisible
          url="teamtask/board"
          :changeGrid="true"
          actionClass="d-flex align-items-center justify-content-between"
          :notDropdown="true"
          :filterList="filters"
          :getData="getData"
        />
      </template>
      <template v-slot:Pagination>
        <Pagination :paginationData="dataTable.pagination" :pageOptions="pageOptions" :dropDownListItems="dropDownListItems" :getData="getData">
          <template v-slot:excel>
            <Excel :link="downloadLink" />
          </template>
        </Pagination>
      </template>
    </Table> -->
    </div>
    <Loader v-if="loading" :loading="loading" />
  </div>
</template>
<style scoped>
::v-deep .dropdown-menu.show {
  top: -85px !important;
  left: 0 !important
}
::v-deep .card-body div.mb-0 {
  min-height: 69vh !important;
}
::v-deep .card-body {
  min-height: 84vh !important;
}
::v-deep .card {
  margin-bottom: 0 !important;
}
::v-deep .ellipsis .colorDiv {
  position: relative !important;
}
::v-deep .preloader-component {
  height: calc(100vh - 110px);
}
</style>
